module.exports = __webpack_public_path__ + "static/media/background.2f525e7a.jpg";